import React from 'react';
import { useRefinementList } from 'react-instantsearch-hooks-web';
import { FacetProps } from './types';
import { textToColor } from '@/helpers/utils/textToColor/textToColor';

const ColorFacet: React.FC<FacetProps> = ({ attribute }) => {
  const { items, refine } = useRefinementList({ attribute });

  return (
    <div className="grid grid-cols-3 items-center justify-start gap-x-[54px] gap-y-[36px] lg:min-w-[340px]">
      {items
        .filter((item) => item.count > 0)
        .map(({ label, value, isRefined, count }) => {
        const color = textToColor(value);
        return (
          <div
            key={value}
            className="flex cursor-pointer flex-col items-center text-center"
            onClick={() => refine(value)}
          >
            <div
              className={`h-[40px] w-[40px] rounded-full outline outline-1 outline-offset-1 ${
                isRefined ? 'outline-gray-500' : 'outline-transparent'
              }`}
              style={{ backgroundColor: color.code }}
            />
            <span className="mt-[4px] block max-w-full truncate text-[14px]" title={color.label}>
              {label}
            </span>
            <span className="mt-[2px] block text-[14px] text-secondary-black">{color.label}</span>
          </div>
        );
      })}
    </div>
  );
};

export default ColorFacet;
